import Compressor from "compressorjs";
import { API_URL, END_POINTS, MEDIA_URL } from "../constants/urls";
import { getFromStorage, STORAGE_KEYS } from "../helpers";

interface UploadResponse {
  statusCode: number;
  data: { image: string; vehicleDetails?: VehicleDetails };
  message: string;
}

export interface VehicleDetails {
  isVehicle: string;
  make: string;
  model: string;
  year: string;
  color: string;
  view: string;
  description: string;
  specifications: Specifications;
}

export interface Specifications {
  bodyType: string;
  doors: string;
  interiorMaterial: string;
  sunroof: string;
  wheels: string;
  dashboard: string;
}

const appendQueryParams = (url: string, queryParams?: any) => {
  if (!queryParams) return url;
  const query = new URLSearchParams(queryParams).toString();
  return `${url}?${query}`;
};

export const UploadMedia = (
  imageObject: any,
  queryParams?: string
): Promise<UploadResponse> => {
  const tokenKey = getFromStorage(STORAGE_KEYS.token);

  return new Promise((resolve, reject) => {
    // eslint-disable-next-line no-new
    new Compressor(imageObject, {
      quality: 0.6,

      success: (compressedResult) => {
        (async () => {
          const formData = new FormData();
          formData.append("file", compressedResult as any);

          const headers = {
            Accept: "application/json",
            authorization: `Bearer ${tokenKey}`,
            "x-portal": "user",
          };

          const url = appendQueryParams(MEDIA_URL!, { UserId: queryParams });

          try {
            const res = await fetch(url!, {
              method: "POST",
              headers,
              body: formData,
            });

            const response = await res.json();
            resolve(response);
          } catch (error) {
            reject("Something went wrong");
          }
        })();
      },

      error: () => {
        reject("Compression failed");
      },
    });
  });
};

export const UploadOfferImage = async (
  imageObject: any
): Promise<UploadResponse> => {
  const tokenKey = getFromStorage(STORAGE_KEYS.token);
  const formData = new FormData();
  formData.append("images", imageObject as any);

  const headers = {
    Accept: "application/json",
    authorization: `Bearer ${tokenKey}`,
  };

  try {
    const res = await fetch(`${API_URL}/${END_POINTS.uploadOfferImage!}`, {
      method: "POST",
      headers,
      body: formData,
    });
    return await res.json();
  } catch (error) {
    console.error(error, ">>>>>>>>> UploadOfferImage error");
    throw new Error("Something went wrong");
  }
};
